import { useEncrypt } from "../hooks/useEncrypt"

const GetStorageUser = () => {
    const { decrypt } = useEncrypt()

    const userData = localStorage.getItem('user')
    
    if (!userData) {
        return userData
    }
    
    const decryptData = decrypt(userData)
    
    return JSON.parse(decryptData)
}

export default GetStorageUser